import React from "react";
import "./ButtonHoverStyle.css";



export const ButtonHover = ({text, color, size, onClick = null}) => {

  const buttonStyle = `${color} ${size}`;
  return (
    <div>
      <button className={`buttons ${buttonStyle}`} onClick={onClick}>{text}</button>
    </div>
  )
}




